import "core-js/modules/es.array.sort.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
var _excluded = ["alt", "src", "density", "className", "id", "style", "breakpoint"],
  _excluded2 = ["alt", "src", "density", "className", "id", "style", "breakpoint"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
import "core-js/modules/es.array.sort.js";
/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import getConfig from '../../js/settings';
import './_index.scss';
var BREAKPOINT_DPI_DEFAULT = getConfig('BREAKPOINT_DPI_DEFAULT');
var BREAKPOINT = getConfig('BREAKPOINT');
var Image = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Image, _React$Component);
  function Image() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.DEFAULT_BREAKPOINT = ['l', 'xl', 'xxl', 'm', 's'];
    _this.FILE_TYPE = {
      'apng': 'image/apng',
      'bmp': 'image/bmp',
      'gif': 'image/gif',
      'jpg': 'image/jpeg',
      'jpeg': 'image/jpeg',
      'png': 'image/png',
      'svg': 'image/svg+xml',
      'webp': 'image/webp'
    };
    return _this;
  }
  var _proto = Image.prototype;
  _proto.getDensity = function getDensity() {
    var attrs = this.props.density;
    var result = [];
    if (attrs) {
      result = attrs.sort(function (a, b) {
        return parseFloat(a) - parseFloat(b);
      });
    } else {
      result.push(BREAKPOINT_DPI_DEFAULT);
    }
    return result;
  };
  _proto.getBreakpoint = function getBreakpoint() {
    var attrs = this.props.breakpoint;
    var result = [];
    if (attrs) {
      result = attrs.map(function (i) {
        return {
          name: i,
          width: BREAKPOINT[i].width
        };
      }).sort(function (a, b) {
        return b.width - a.width;
      });
    } else {
      result.push({
        name: this.DEFAULT_BREAKPOINT[0],
        width: BREAKPOINT[this.DEFAULT_BREAKPOINT[0]].width
      });
    }
    return result;
  };
  _proto.getSrcParts = function getSrcParts() {
    var allowedExtensions = Object.keys(this.FILE_TYPE).join('|');
    var re = new RegExp("^(.+)\\.(" + allowedExtensions + ")$", 'i');
    var matches = this.props.src.match(re);
    return matches.length > 2 ? {
      file: matches[1],
      extension: matches[2]
    } : null;
  };
  _proto.getDefaultImgBreakpoint = function getDefaultImgBreakpoint(breakpoint) {
    if (breakpoint.length <= 0) return null;
    var def = breakpoint[0];
    var _loop = function _loop() {
      var i = _step.value;
      var filtered = breakpoint.filter(function (j) {
        return j.name === i;
      });
      if (filtered.length > 0) {
        def = filtered[0];
        return "break";
      }
    };
    for (var _iterator = _createForOfIteratorHelperLoose(this.DEFAULT_BREAKPOINT), _step; !(_step = _iterator()).done;) {
      var _ret = _loop();
      if (_ret === "break") break;
    }
    return def;
  };
  _proto.getPicture = function getPicture(_breakpoint) {
    var _this2 = this;
    var _this$props = this.props,
      alt = _this$props.alt,
      src = _this$props.src,
      density = _this$props.density,
      className = _this$props.className,
      id = _this$props.id,
      style = _this$props.style,
      breakpoint = _this$props.breakpoint,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    var parts = this.getSrcParts();
    if (!parts || !this.FILE_TYPE.hasOwnProperty(parts.extension)) return this.getImg();
    var type = this.FILE_TYPE[parts.extension];
    var _density = this.getDensity();
    var sources = _breakpoint.map(function (i, index, arr) {
      var media = i.width > 0 && index + 1 < arr.length ? "(min-width: " + i.width + "px)" : null;
      var srcSet = _this2.getSrcSet(_density, parts.file + "-" + i.name, parts.extension);
      var key = index;
      return {
        media: media,
        srcSet: srcSet,
        key: key
      };
    });
    var imgBreakpoint = this.getDefaultImgBreakpoint(_breakpoint);
    var img = _objectSpread(_objectSpread({}, rest), {}, {
      alt: alt,
      src: parts.file + "-" + imgBreakpoint.name + "." + parts.extension,
      className: className,
      id: id,
      style: style
    });
    if (_density.length > 1) {
      img.srcSet = this.getSrcSet(_density, parts.file + "-" + imgBreakpoint.name, parts.extension);
      img.src = parts.file + "-" + imgBreakpoint.name + "-" + _density[0] + "x." + parts.extension;
    }
    return /*#__PURE__*/React.createElement("picture", null, sources.map(function (i) {
      return /*#__PURE__*/React.createElement("source", Object.assign({
        type: type
      }, i));
    }), /*#__PURE__*/React.createElement("img", img));
  };
  _proto.getSrcSet = function getSrcSet(density, file, extension) {
    return density.length > 1 ? density.map(function (i) {
      return file + "-" + i + "x." + extension + " " + i + "x";
    }).join(', ') : file + "." + extension;
  };
  _proto.getImg = function getImg() {
    var _this$props2 = this.props,
      alt = _this$props2.alt,
      src = _this$props2.src,
      density = _this$props2.density,
      className = _this$props2.className,
      id = _this$props2.id,
      style = _this$props2.style,
      breakpoint = _this$props2.breakpoint,
      rest = _objectWithoutPropertiesLoose(_this$props2, _excluded2);
    var props = _objectSpread({
      alt: alt,
      src: src,
      className: className,
      id: id,
      style: style
    }, rest);
    var _density = this.getDensity();
    var parts = this.getSrcParts();
    if (_density.length > 1 && parts) {
      props.src = parts.file + "-" + _density[0] + "x." + parts.extension;
      props.srcSet = this.getSrcSet(_density, parts.file, parts.extension);
    }

    // eslint-disable-next-line jsx-a11y/alt-text
    return /*#__PURE__*/React.createElement("img", props);
  };
  _proto.render = function render() {
    var breakpoint = this.getBreakpoint();
    return breakpoint.length > 1 ? this.getPicture(breakpoint) : this.getImg();
  };
  return Image;
}(React.Component);
Image.defaultProps = {
  alt: ''
};
export default Image;